import React from 'react'
import { useSelector } from 'react-redux'
import { Button, Col, Modal, Row } from 'antd'
import styled from 'styled-components'
import _ from 'lodash'

const SelectItem = styled.div`
  height: 30px;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;

  ${(props) =>
    props.active &&
    `
            background: #f6ffed;
            border-color: green;
            color: green;
    `}
`

const AddProductFeatureModal = ({
  visible,
  onOk,
  onCancel,
  formData,
  setFormProductFeatureData
}) => {
  const { productFeatureList } = useSelector(
    (state) => ({
      productFeatureList: state.productFeature.productFeatureList
    }),
    []
  )

  const renderItemActive = (id) => {
    let active = false
    if (!_.isEmpty(formData.productFeaturesList)) {
      active = formData.productFeaturesList.some((productFeature) => {
        return productFeature.id === id
      })
    }
    return active
  }

  function onClickItem(item) {
    const added = _.some(formData.productFeaturesList, (productFeature) => {
      return productFeature.id === item.id
    })
    if (added) {
      const arr = formData.productFeaturesList.filter(
        (productFeature) => productFeature.id !== item.id
      )
      const data = {
        barcodeId: formData.barcodeId,
        productFeaturesList: arr
      }
      data.productFeaturesList = arr
      setFormProductFeatureData(data)
    } else {
      const arr = [...formData.productFeaturesList]
      arr.push(item)
      const data = {
        barcodeId: formData.barcodeId,
        productFeaturesList: arr
      }
      setFormProductFeatureData(data)
    }
  }

  return (
    <Modal
      title="Add Product Features"
      visible={visible}
      closable={false}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onCancel()
          }}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            onOk()
          }}>
          Add
        </Button>
      ]}>
      <Row type="flex" gutter={[8, 8]}>
        {productFeatureList.map((item, index) => {
          return (
            <Col key={index}>
              <SelectItem
                onClick={() => onClickItem(item)}
                active={renderItemActive(item.id)}>
                {item.detail}
              </SelectItem>
            </Col>
          )
        })}
      </Row>
    </Modal>
  )
}

export default AddProductFeatureModal



// WEBPACK FOOTER //
// ./src/pages/BrandProduct/AddProductFeatureModal/index.js